import { render, staticRenderFns } from "./Clusters.vue?vue&type=template&id=5ebfe1bc&scoped=true"
import script from "./Clusters.vue?vue&type=script&lang=js"
export * from "./Clusters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebfe1bc",
  null
  
)

export default component.exports